import React from 'react';
import { Quote } from 'lucide-react';
import Reveal from '@/components/Reveal';
import { CASE_STUDIES } from '@/data/metaOffer';

export default function MetaCaseStudies() {
  return (
    <section id="results" className="bg-white py-20 lg:py-28">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl mb-14">
          <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#2563EB] block mb-4">
            Case Studies
          </span>
          <h2 className="font-display font-bold text-[#0B0B0B] tracking-tight text-3xl lg:text-5xl leading-tight">
            Results our clients can point to
          </h2>
          <p className="mt-6 text-[#0B0B0B]/60 font-light leading-relaxed">
            Six engagements, six different starting points. Each began with the same free breakdown you can request on
            this page.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {CASE_STUDIES.map((c, i) => (
            <Reveal key={c.client + i} delay={(i % 3) * 0.1}>
              <article className="h-full flex flex-col rounded-lg border border-[#0B0B0B]/10 bg-[#F5F5F5] p-7 hover:border-[#2563EB]/50 transition-colors duration-500">
                <Quote className="w-6 h-6 text-[#2563EB]" />
                <p className="mt-5 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#0B0B0B]/45">
                  {c.client}
                </p>
                <h3 className="mt-2 font-display font-bold text-xl text-[#0B0B0B] tracking-tight">{c.result}</h3>
                <p className="mt-4 text-sm text-[#0B0B0B]/60 font-light leading-relaxed flex-1">{c.detail}</p>
                <p className="mt-6 pt-5 border-t border-[#0B0B0B]/10 font-display font-bold text-[#2563EB]">
                  {c.metric}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}